class QuantityInput {
    /**
     * QuantityInput constructor
     *
     * @param $inputElement
     * @param $plusElement
     * @param $minusElement
     */
    constructor($inputElement = null, $plusElement = null, $minusElement = null) {

        //bail if already initiated
        if ($inputElement.classList.contains('quantity-input--initiated')) return

        //validations
        if ($inputElement === null || !$inputElement instanceof HTMLInputElement) throw new Error('Missing required parameter `$inputElement` in class QuantityInput or given parameter was not an input element')
        if ($plusElement === null || !$plusElement instanceof Element) throw new Error('Missing required parameter `$plusElement` in class QuantityInput or given parameter was not a valid element')
        if ($minusElement === null || !$minusElement instanceof Element) throw new Error('Missing required parameter `$minusElement` in class QuantityInput or given parameter was not a valid element')

        //create initial state
        this.state = {
            $inputElement: $inputElement,
            $plusElement: $plusElement,
            $minusElement: $minusElement,
            $updateButton: document.querySelector('button[name=update_cart]'),
            value: parseInt($inputElement.value),
            step: parseInt($inputElement.getAttribute("step")) || 1,
            min: parseInt($inputElement.getAttribute("min")) || 1,
            max: parseInt($inputElement.getAttribute("max")) || 9999
        }

        //bind events
        this.state.$inputElement.addEventListener("input", this.handleInput.bind(this))
        this.state.$inputElement.addEventListener("change", this.handleInputChange.bind(this))
        this.state.$plusElement.addEventListener("click", this.handlePlusClick.bind(this))
        this.state.$minusElement.addEventListener("click", this.handleMinusClick.bind(this))

        //set initiated class to prevent multiple inits
        $inputElement.classList.add('quantity-input--initiated')
    }

    /**
     * Handle input change
     * @param event
     */
    handleInput(event) {
        const newValue = parseInt(this.state.$inputElement.value)
        this.updateValue(newValue, false)
    }

    /**
     * Handle input change
     * @param event
     */
    handleInputChange(event) {
        const newValue = parseInt(this.state.$inputElement.value)
        this.updateValue(newValue)
    }

    /**
     * Handle plus click
     * @param event
     */
    handlePlusClick(event) {
        if (event) event.preventDefault()
        this.updateValue(this.state.value + this.state.step)
    }

    /**
     * Handle minus click
     * @param event
     */
    handleMinusClick(event) {
        if (event) event.preventDefault()
        const newValue = this.state.value - this.state.step
        if (newValue >= this.state.min) this.updateValue(newValue)
    }

    /**
     * Update value in state and input
     * @param newValue {string|int}
     * @param update {boolean}
     */
    updateValue(newValue, update = true) {
        this.state.value = newValue
        this.state.$inputElement.value = newValue

        //force update on quantity input change
        if (update && this.state.$updateButton) {
            this.state.$updateButton.disabled = false
            this.state.$updateButton.click()
            this.state.$updateButton.disabled = true
        }
    }
}

export default QuantityInput